<template>
  <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable max-width="600px" :transition="transition">

    <!-- The following card is the welcome screen. it should only display if specifically triggered-->
    <!-- TODO: Break this out into a separate component: Onboarding -->
    <v-card flat color="primary" v-if="opened" v-show="this.showSplash" class="fade-in one">
      <v-toolbar flat>
        <v-btn @click="cancel()" dark icon><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout v-show="this.stage === 1" column>
          <v-layout justify-center row>
          <span class="fade-in one mb-3" style="color:white; font-weight:700; font-size:28px;">Welcome to OneChart</span>
        </v-layout>
        <v-layout justify-center row>
        <v-layout class="fade-in oneLong mx-3 mb-3" style="max-width:500px;" row>
                <v-layout column style="margin-right:20px;">
                  <v-icon large color="white">description</v-icon>
                </v-layout>
                <v-layout column>
                  <span style="color:white; font-weight:300; font-size:24px;">Collect medical records from wherever care was received.</span>
                </v-layout>
              </v-layout>
        </v-layout>
        <v-layout justify-center row>
        <v-layout class="fade-in twoLong mx-3 mb-3" style="max-width:500px;" row>
                <v-layout column style="margin-right:20px;">
                  <v-icon large color="white">important_devices</v-icon>
                </v-layout>
                <v-layout column>
                  <span style="color:white; font-weight:300; font-size:24px;">Access the chart from any internet connected device.</span>
                </v-layout>
              </v-layout>
        </v-layout>
        <v-layout justify-center row>
        <v-layout class="fade-in threeLong mx-3 mb-3" style="max-width:500px;" row>
                <v-layout column style="margin-right:20px;">
                  <v-icon large color="white">group</v-icon>
                </v-layout>
                <v-layout column>
                  <span style="color:white; font-weight:300; font-size:24px;">Share with any doctor, care team member, or anyone else.</span>
                </v-layout>
              </v-layout>
        </v-layout>
        </v-layout>
        <v-layout v-show="this.stage === 2" column>
          Select Provider or not
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-toolbar flat>
          <v-spacer></v-spacer>
        <v-btn @click="createPatient()" depressed>Create a Chart</v-btn>
      </v-toolbar>
      </v-card-actions>

    </v-card>
   
  </v-dialog>
</template>

<style scoped>
.input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border: 1px solid #eeeeee;
  padding: 5px;
  width: 100%;
  border-radius: 4px;
  font-size: 18px;
  height: 36px;
  margin-top: 16px;
  background: white;
}

.welcomeLayout {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  max-height: 600px;
}
</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import HelperMixin from '@/core/mixins/HelperMixin'
import { mapActions, mapState } from 'vuex'
import bus from '@/core/helpers/bus'

export default {
  name: 'EditProfile',
  mixins: [DialogMixin, HelperMixin],
  data() {
    return {
      stage: 1,
      firstNameInput: '',
      lastNameInput: '',
      phoneInput: '',
      birthdateInput: '',
      genderInput: '',
      line1Input: '',
      line2Input: '',
      cityInput: '',
      stateInput: '',
      zipInput: '',
      partner: null,
      accessCode: null,
      newPatientMode: false,
      attributePatientMode: false,
      showSplash: false,
      profileValid: false,
      addressValid: false,
      opened: false,
      phoneMask: 'phone',
      notifications: false,
      sound: true,
      widgets: false,
      date: null,
      menu: false,
      state: null,
      dateTicker: 3,
      stateValidation: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
      firstNameRules: [v => !!v || 'First name is required'],
      lastNameRules: [v => !!v || 'Last name is required'],
      phoneRules: [v => !!v || 'Phone number is required'],
      birthdateRules: [v => !!v || 'Birthdate is required'],
      line1Rules: [v => !!v || 'Street address is required'],
      cityRules: [v => !!v || 'City is required'],
      stateRules: [v => !!v || 'State is required'],
      stateValidationRule: [v => this.stateValidation.includes(v) || 'Invalid State'],
      zipRules: [v => !!v || 'Zip Code is required']
    }
  },
  computed: {
    ...mapState('registration', ['type']),
    ...mapState('patient', ['patient', 'files', 'requests']),
    ...mapState('auth', ['user']),
    profile() {
      if (this.patient.gender && !this.newPatientMode) {
        this.profileValid = true
        this.addressValid = true
        this.date = this.formatDate(this.patient.birthdate)
        return {
          firstName: this.patient.firstName,
          lastName: this.patient.lastName,
          phone: this.patient.phone,
          birthdate: this.patient.birthdate,
          gender: this.patient.gender,
          address: {
            line1: this.patient.address.line1,
            line2: this.patient.address.line2,
            city: this.patient.address.city,
            state: this.patient.address.state,
            zip: this.patient.address.zip
          }
        }
      }

      return {
        firstName: '',
        lastName: '',
        phone: '',
        birthdate: null,
        gender: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        }
      }
    }
  },
  methods: {
    ...mapActions('patient', [
      'createPatient',
      'createPatientWithProvider',
      'updatePatient',
      'getPatient'
    ]),
    createPatient() {
      this.$router.push({
        name: 'PatientProfilePage',
        query: this.$route.query
      })
    },
    onClose() {
      this.opened = false
    },
    onOpen() {
      this.opened = true
      if (this.options.newPatientMode) {
        this.newPatientMode = true
        this.showSplash = false
        this.date = null
      } else {
        this.firstNameInput = this.profile.firstName
        this.lastNameInput = this.profile.lastName
        this.phoneInput = this.profile.phone
        this.birthdateInput = this.formatDate(this.profile.birthdate)
        this.genderInput = this.profile.gender
        this.line1Input = this.profile.address.line1
        this.line2Input = this.profile.address.line2
        this.cityInput = this.profile.address.city
        this.stateInput = this.profile.address.state
        this.zipInput = this.profile.address.zip
      }

      if (this.options.partner && this.options.accessCode) {
        this.newPatientMode = true
        this.attributePatientMode = true
        this.partner = this.options.partner
        this.accessCode = this.options.accessCode
      }

      if (this.options.triggerWelcome) {
        this.showSplash = true
        this.firstNameInput = this.user.firstName
        this.lastNameInput = this.user.lastName
      }
    },
    unixBirthdate(date) {
      if (date !== '') {
        let extractedNumbers = date.replace(/\D/g, '')
        let constructedDate = new Date(extractedNumbers.slice(4, 8), extractedNumbers.slice(0, 2) - 1, extractedNumbers.slice(2, 4))
        if (constructedDate.getTime()) {
          return Date.UTC(constructedDate.getFullYear(), constructedDate.getMonth(), constructedDate.getDate(), 12) / 1000
        } else {
          this.toast('error', 'Invalid Birthdate')
        }
      }
    },
    formatDate(timestamp) {
      return this.getBirthdateStringFromTimestamp(timestamp)
    },
    createFirstChart() {
      this.showSplash = false
    },
    checkBirthdate(birthdate) {
      let today = Math.floor(Date.now() / 1000)
      if (birthdate) {
        if (birthdate > today + 86400) {
          return false
        }
        return true
      } else {
        return false
      }
    },
    checkInfo(patient) {
      let patientInfoComplete = true
      let errorNote = ''
      if (!patient.firstName) {
        patientInfoComplete = false
        errorNote = 'First name Required'
      }
      if (!patient.lastName) {
        patientInfoComplete = false
        errorNote = 'Last name Required'
      }
      if (!patient.phone) {
        patientInfoComplete = false
        errorNote = 'Phone Required'
      }
      if (!patient.birthdate) {
        patientInfoComplete = false
        errorNote = 'Birthdate Required'
      } else {
        // get today's date and check it against the birthdate. today's date should be after the birthdate
        patientInfoComplete = this.checkBirthdate(patient.birthdate)
        if (!patientInfoComplete) {
          errorNote = 'Invalid Birthdate'
        }
      }
      if (!patient.gender) {
        patientInfoComplete = false
        errorNote = 'Gender Required'
      }
      if (!patient.address) {
        patientInfoComplete = false
        errorNote = 'Address Required'
      } else {
        if (!patient.address.line1) {
          patientInfoComplete = false
          errorNote = 'Street Address Required'
        }
        if (!patient.address.city) {
          patientInfoComplete = false
          errorNote = 'City Required'
        }
        if (!patient.address.state) {
          patientInfoComplete = false
          errorNote = 'State Required'
        }
        if (!patient.address.zip) {
          patientInfoComplete = false
          errorNote = 'Zip Code Required'
        }
      }

      if (!patientInfoComplete) {
        this.toast('error', errorNote)
      }

      return patientInfoComplete
    },
    submit() {
      // this should
      const patient = {}
      if (this.firstNameInput !== this.profile.firstName) {
        patient.firstName = this.firstNameInput
      }
      if (this.lastNameInput !== this.profile.lastName) {
        patient.lastName = this.lastNameInput
      }
      if (this.phoneInput !== this.profile.phone) {
        patient.phone = this.phoneInput
      }
      if (this.birthdateInput !== this.formatDate(this.profile.birthdate)) {
        patient.birthdate = this.unixBirthdate(this.birthdateInput)
      }
      if (this.genderInput !== this.profile.gender) {
        patient.gender = this.genderInput
      }
      // the address has to be updated together
      let addressChanged = false
      if (this.line1Input !== this.profile.address.line1) {
        addressChanged = true
      }
      if (this.line2Input !== this.profile.address.line2) {
        addressChanged = true
      }
      if (this.cityInput !== this.profile.address.city) {
        addressChanged = true
        if (patient.address) {
          patient.address.city = this.cityInput
        } else {
          patient.address = {}
          patient.address.city = this.cityInput
        }
      }
      if (this.stateInput !== this.profile.address.state) {
        addressChanged = true
      }
      if (this.zipInput !== this.profile.address.zip) {
        addressChanged = true
      }

      if (addressChanged) {
        patient.address = {}
        patient.address.line1 = this.line1Input
        patient.address.line2 = this.line2Input
        patient.address.city = this.cityInput
        patient.address.state = this.stateInput
        patient.address.zip = this.zipInput
      }
      if (this.partner && this.accessCode) {
        if (this.checkInfo(patient)) {
          // about to create a partner patient
          this.createPatient(patient).then((patientCreated) => {
            const id = this.partner
            const code = this.accessCode
            const patientID = patientCreated._id
            this.createPatientWithProvider({ patientID, id, code }).then(() => {
              this.partner = null
              this.accessCode = null
              const patient = patientID
              this.$router.push({
                name: 'PatientPage',
                params: { id: patient }
              })
              this.ok()
            })
          })
        } else {
          console.log('incomplete patient information')
        }
      } else if (this.newPatientMode) {
        if (this.checkInfo(patient)) {
          this.createPatient(patient).then((patientCreated) => {
            const patientID = patientCreated._id
            const patient = patientID
            this.$router.push({
              name: 'PatientPage',
              params: { id: patient }
            })
            this.ok()
          })
        } else {
          console.log('incomplete patient information')
        }
      } else {
        let birthdateGood = true
        if (patient.birthdate) {
          birthdateGood = this.checkBirthdate(patient.birthdate)
        }
        if (birthdateGood) {
          this.updatePatient({
            id: this.$route.params.id,
            payload: patient
          }).then(() => {
            this.getPatient({ id: this.$route.params.id })
            this.show = false
          })
        } else {
          this.toast('error', 'Invalid Birthdate')
        }
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
    this.$on('close', this.onClose)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/EditPatientInfoDialog.vue